var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.811,
    height: 28.196,
    viewBox: "0 0 39.811 28.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1812.949 -2695.726) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2714.466,1802.058c0-2.7.02-5.414-.011-8.121-.007-.745.2-.962.8-.952,1.992.04,3.983,0,5.973.021a2.4,2.4,0,0,0,2.487-1.659,3.462,3.462,0,0,0-.74-3.494q-5.577-6.76-11.166-13.51c-1.334-1.609-2.659-1.606-3.992,0q-5.559,6.717-11.106,13.446a3.335,3.335,0,0,0-.453,4.158,2.264,2.264,0,0,0,2.1,1.049c1.993.006,3.983.034,5.973-.014.654-.016.835.231.833,1.01-.027,5.118-.016,10.236-.009,15.353a10.2,10.2,0,0,0,.088,1.377c.159,1.188.709,2.032,1.672,2.1a39.1,39.1,0,0,0,5.624.047c1.319-.1,1.909-1.137,1.915-2.783C2714.474,1807.409,2714.466,1804.734,2714.466,1802.058Z",
    fill: "#bebebe",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.2f9e56cf.svg";
export { ForwardRef as ReactComponent };